<p class="title">Авторизация</p>
<form>
    <input [(ngModel)]="login" name="login" placeholder="Логин">
    <input [(ngModel)]="pass" name="pass" placeholder="Пароль" type="password">
    <select *ngIf="!without_signature_mode" [(ngModel)]="selectedCert" name="selectedCert" class="form-control-sm" style="margin: 10px;">
        <option value=""></option>
        <option *ngFor="let cert of certsList" [value]="cert.thumbprint">{{ cert.name }} [{{ cert.thumbprint }}]</option>
    </select>
    <p *ngIf="error" class="error">{{error}}</p>
    <input (click)="log_in()" type="button" value="Войти">
</form>



// WEBPACK FOOTER //
// ./src/app/pages/auth/auth.template.html